import Lottie from 'lottie-react';
import spinner from '../assets/animations/spinner.json';

export function LottieSpinner() {
  return <Lottie loop={true} animationData={spinner} data-testid="loading-spinner" />;
}
